import FontBody2 from '../fonts/font-body2/font-body2';
import { FONT_COLOR, FONT_VARIANT } from '../fonts/font-props';
import IconInfo from '../icons/icon-info/icon-info';
import Icon from '../icons/icon/icon';
import { GridColumn, useGridStyleHook } from '../layouts/hooks/grid-style-hook';
import { Tooltip } from '../tooltip/tooltip';
import './form-field-line.scss';

interface IGridStyle {
    lableWidth: GridColumn;
    childrenWidth: GridColumn;
}

const INDENT_SIZE = 30;

interface IFormFieldLineProps {
    label: string;
    children?: React.ReactNode;
    labelIndent?: number; /** number of Tabs to indent the label */
    required?: boolean;
    note?: React.ReactNode;
    tooltip?: React.ReactNode;
    disabled?: boolean;
    gridStyle?: IGridStyle;
    dataName?: string; /** used by Candu to target an element */
}

export const FormFieldLine: React.FC<IFormFieldLineProps> = ({
    label,
    children,
    labelIndent = 0,
    required = false,
    note,
    tooltip,
    disabled,
    gridStyle = {
        lableWidth: { width: 1, type: 'fr' },
        childrenWidth: { width: 1, type: 'fr' },
    },
    dataName
}) => {
    const disabledClass = disabled ? 'disabled' : '';
    const style = useGridStyleHook(
        { columns: [gridStyle?.lableWidth as GridColumn, gridStyle?.childrenWidth as GridColumn] }, 
        []
    );

    const applyIndent = (labelIndent ?? 0) * INDENT_SIZE;

    return (
        <div className={`form-field-line ${disabledClass}`} style={style}>
            <div data-name={dataName ?? ''} className={`field-text ${tooltip && `has-tooltip`}`} style={{ marginLeft: `${applyIndent}px` }}>
                <FontBody2 color={FONT_COLOR.PRIMARY2}>
                    {label}
                    {required && <FontBody2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.ACCENT3}>&nbsp;*</FontBody2>}
                    {tooltip && <Tooltip content={tooltip}><Icon Component={IconInfo} /></Tooltip>}
                </FontBody2>
                {note && 
                    <FontBody2 color={FONT_COLOR.NEUTRAL3}>
                        {note}
                    </FontBody2>
                }
            </div>
            { children && children }
        </div>
    );
}